import script from "./EquipmentTemplates.vue?vue&type=script&setup=true&lang=ts"
export * from "./EquipmentTemplates.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__